import React, { Component } from "react";
import { connect } from "react-redux";
import { msg } from "../../constants";
import { Link } from "react-router-dom";
import RegisterModal from "./RegisterModal";
const locale = require("react-redux-i18n").I18n;

class RegisterFooter extends Component {
  state = {
    modalShow: false
  };

  handleModalClose = () => {
    this.setState({
      modalShow: false
    });
  };

  render() {
    const { custTermCondTitle, custTermCondSubTitle, custTermCond } = msg;
    return (
      <div>
        {this.props.mode === "Edit" && (
          <div className="box-register_form-footer">
            <p>
              {locale.t("clickToAgree")}
              <a href="#!" onClick={() => this.setState({ modalShow: true })}>
                {locale.t("detaiHere")}
              </a>
              {locale.t("beforeEdit")}
            </p>
            <div className="box-btn flex-center">
              <Link
                to={"/shop/" + this.props.project.project_encrypt}
                className="btn btn-cc"
              >
                {locale.t("cancel")}
              </Link>
              <button
                type="submit"
                className="btn btn-cf"
                disabled={this.props.disabled}
              >
                {locale.t("agreeProfile")}
              </button>
            </div>
            <RegisterModal
              show={this.state.modalShow}
              onOK={this.handleModalClose}
              title={custTermCondTitle}
              subTitle={custTermCondSubTitle}
              detail={custTermCond}
            />
          </div>
        )}
        {this.props.mode === "Expire" && (
          <div className="box-register_form-footer">
            <div className="box-btn flex-center">
              {/* <button type="button" className="btn btn-cc">ยกเลิก</button> */}
              <Link
                to={"/shop/" + this.props.project.project_encrypt}
                className="btn btn-cc"
              >
                {locale.t("cancel")}
              </Link>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  project: state.project.info,
  l: state.i18n.locale
});

export default connect(mapStateToProps)(RegisterFooter);
